module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic5.8d0f5def.png";